import { call, put, takeEvery } from 'redux-saga/effects';
import { getJSON } from '../util';

export function* getPsychics({ payload }) {
    const mode = payload && payload.mode ? payload.mode : null;
    const limit = /^m[.-]/.test(window.location.hostname) ? 1 : 2;
    const response = yield call(getJSON, `/api/psychics?mode=${mode}`);
    const opsychics = response && Array.prototype.slice.call(response.querySelectorAll('psychic'), 0, limit);
    const psychics = opsychics.map(psychic => {
        return {
            likes: psychic.querySelector('likes').textContent,
            link: psychic.querySelector('link').textContent,
            performerid: psychic.querySelector('performerid').textContent,
            thumb: psychic.querySelector('thumb').textContent,
        };
    });

    yield put({
        type: 'oranum:update',
        payload: {
            psychics: psychics,
        },
    });
}

export function* root() {
    yield takeEvery('oranum:get-psychics', getPsychics);
}
